import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";

/** Resets the error screen whenever the learner navigates somewhere else. */
export function RoutedErrorBoundary({
  children
}: {
  children: ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  return <ErrorBoundary resetKey={pathname} data-id="element-547" data-mp="31js4accsp436">{children}</ErrorBoundary>;
}